import { Store } from "../../../ducks/store";
import { FavoriteStoreSelectItem } from "../../molecules/store/FavoriteStoreSelectItem";

type Props = {
  favoriteStores: Store[];
  onSelect: (address: string) => void;
};

export const FavoriteStoreSelection: React.FC<Props> = ({
  favoriteStores,
  onSelect,
}) => {
  if (favoriteStores.length === 0) return null;

  return (
    <>
      {favoriteStores.map((store) => (
        <FavoriteStoreSelectItem
          key={store.id}
          name={store.name}
          onSelect={() =>
            onSelect(store.prefecture + store.city + store.address)
          }
        />
      ))}
    </>
  );
};
